import React from "react";
import { formatEnquiriesDate, isNewEnquiry } from "../../utils/utils";

const ItemEnquiries = ({ item, isOpen, onToggle }) => {
    return (
        <div
            className={`px-[20px] py-[16px] transition-colors ${isOpen ? "bg-[#fafbff]" : "hover:bg-[#fafafa]"
                }`}
        >
            {/* HEADER */}
            <div
                onClick={onToggle}
                className="flex items-start gap-[12px] cursor-pointer"
            >
                {/* Avatar */}
                <div className="w-[36px] h-[36px] rounded-full flex items-center justify-center shrink-0 bg-[#16a34a] text-white">
                    <span className="font-semibold text-[13px]">
                        {item.userName?.charAt(0)?.toUpperCase()}
                    </span>
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-[8px] mb-[2px]">
                        <div className="flex items-center gap-[8px] min-w-0">
                            <p className="font-semibold text-[14px] text-[#212326] truncate">
                                {item.userName}
                            </p>

                            {isNewEnquiry(item.createdAt) && !item.isRead && (
                                <span className="shrink-0 w-[8px] h-[8px] rounded-full bg-[#16a34a]" />
                            )}
                        </div>

                        <span className="font-medium text-[12px] text-[#9298a0] shrink-0">
                            {formatEnquiriesDate(item.createdAt)}
                        </span>
                    </div>

                    <p className="font-semibold text-[13px] text-[#212326] mb-[2px] truncate">
                        {item.subject || "Customer Enquiry"}
                    </p>

                    <p className="font-medium text-[13px] text-[#717182] truncate">
                        {item.message}
                    </p>
                </div>
            </div>

            {/* EXPANDED DETAILS */}
            {isOpen && (
                <div className="mt-[14px] ml-[48px] bg-[#f8f8fa] rounded-[12px] p-[16px] flex flex-col gap-[12px]">
                    {/* FROM */}
                    <div>
                        <p className="font-medium text-[12px] text-[#9298a0] mb-[4px]">
                            From
                        </p>

                        <p className="font-medium text-[13px] text-[#212326]">
                            {item.userName} ({item.userEmail})
                        </p>
                    </div>

                    {/* REASONS */}
                    {item.topics?.length > 0 && (
                        <div>
                            <p className="font-medium text-[12px] text-[#9298a0] mb-[4px]">
                                Reason
                            </p>

                            <div className="flex gap-[6px] flex-wrap">
                                {item.topics.map((topic) => (
                                    <span
                                        key={topic}
                                        className="bg-white border border-[#e4e5e7] px-[10px] py-[4px] rounded-[8px] font-semibold text-[12px] text-[#53585f]"
                                    >
                                        {topic}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* MESSAGE */}
                    <div>
                        <p className="font-medium text-[12px] text-[#9298a0] mb-[4px]">
                            Message
                        </p>

                        <p className="font-medium text-[13px] text-[#212326] leading-[1.6] whitespace-pre-wrap">
                            {item.message}
                        </p>
                    </div>

                    {/* STATUS */}
                    <div className="flex items-center gap-[6px]">
                        <span
                            className={`px-[10px] py-[4px] rounded-[8px] font-semibold text-[11px] uppercase tracking-[0.3px]
                            ${item.replied
                                    ? "bg-[#e8f8e8] text-[#2ecc71]"
                                    :
                                    item.isRead ? "bg-[#f0f1f3] text-[#717182"
                                        :
                                        "bg-[#f0f4ff] text-[#16a34a]"
                                }`}
                        >
                            {item.replied ? "Replied" : item.isRead ? "Read" : "New"}
                        </span>

                        <span className="font-medium text-[11px] text-[#9298a0]">
                            {new Date(item.createdAt).toLocaleString()}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ItemEnquiries;